/**
 * 地球自转渲染闸门：切底图 setStyle 期间暂停 jumpTo，
 * 避免 Mapbox fog.state 未就绪时 getOpacityAtLatLng 崩溃。
 *
 * 另：用户离开地球全景后的会话标记，防止异步切底图把相机拽回 zoom≈1。
 */

let earthSpinRenderPaused = false;

export function pauseEarthSpinRender(paused) {
  earthSpinRenderPaused = !!paused;
}

export function isEarthSpinRenderPaused() {
  return earthSpinRenderPaused;
}

/** 用户已点过空白离开地球：本页会话内禁止再被拉回全景 */
export function markDashboardEarthDismissed(win = typeof window !== 'undefined' ? window : null) {
  if (win) win.__zhxtDashboardEarthDismissed = true;
}

export function clearDashboardEarthDismissed(win = typeof window !== 'undefined' ? window : null) {
  if (!win) return;
  try {
    delete win.__zhxtDashboardEarthDismissed;
  } catch (_) {
    win.__zhxtDashboardEarthDismissed = false;
  }
}

export function isDashboardEarthDismissed(win = typeof window !== 'undefined' ? window : null) {
  if (!win) return false;
  return Boolean(win.__zhxtDashboardEarthDismissed);
}
